import { render, staticRenderFns } from "./SARSDashboard.vue?vue&type=template&id=026d7ba4&scoped=true"
import script from "./SARSDashboard.vue?vue&type=script&lang=js"
export * from "./SARSDashboard.vue?vue&type=script&lang=js"
import style0 from "./SARSDashboard.vue?vue&type=style&index=0&id=026d7ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d7ba4",
  null
  
)

export default component.exports